import { useContext } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import useDebounce from '../../hooks/useDebounce'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import { DialogBody } from '@/components/Dialog'

export default function ScreenRecordingSavingDialogController() {
    const { state: appState } = useContext(AppContext) as AppContextType

    const screenRecordingConversionProgressDebounced = useDebounce(
        appState.appState.screenRecordingConversionProgress,
        500
    )

    if (!screenRecordingConversionProgressDebounced) {
        return null
    }

    return (
        <CrossPlatformDialog show={true} frameName={`Dialog:ScreenRecordingSavingDialog`} onDefaultClose={() => {}}>
            <DialogBody>
                <div className="pb-4" style={{ wordWrap: 'break-word' }}>
                    Processing screen recording <i>{screenRecordingConversionProgressDebounced.fileName}</i>...
                </div>
            </DialogBody>
        </CrossPlatformDialog>
    )
}
